"use client";

import { createContext, useContext, useState, ReactNode } from "react";

interface User {
  id: string;
  nome: string;
  email: string;
  cpf: string;
  tipo: "cidadao" | "admin" | "tecnico";
}

interface AuthContextType {
  user: User | null;
  login: (email: string, senha: string) => boolean;
  logout: () => void;
  register: (data: Omit<User, "id"> & { senha: string }) => boolean;
}

const AuthContext = createContext<AuthContextType | null>(null);

const MOCK_USERS: (User & { senha: string })[] = [
  {
    id: "1",
    nome: "Admin IQUAMA",
    email: "admin@iquama.ce.gov.br",
    cpf: "000.000.000-00",
    tipo: "admin",
    senha: "admin123",
  },
  {
    id: "2",
    nome: "João Silva",
    email: "joao@email.com",
    cpf: "111.222.333-44",
    tipo: "cidadao",
    senha: "123456",
  },
];

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);

  const login = (email: string, senha: string) => {
    const found = MOCK_USERS.find(
      (u) => u.email === email && u.senha === senha
    );
    if (found) {
      const { senha: _, ...userData } = found;
      setUser(userData);
      return true;
    }
    return false;
  };

  const logout = () => setUser(null);

  const register = (data: Omit<User, "id"> & { senha: string }) => {
    const newUser: User = { ...data, id: String(Date.now()) };
    MOCK_USERS.push({ ...newUser, senha: data.senha });
    setUser(newUser);
    return true;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
